import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";

const MyUnlockRequest = () => {
  const navigate = useNavigate();
  const [offerList, setofferList] = useState([]);
  const [selectId, setSelectId] = useState();
  const [userId, setUserId] = useState();
  const [isProcess, setIsProcess] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const buttonRef = useRef(null);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");
  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }
  }, []);
  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/offer/bids",
        {
          owner_id: storedUserPreferences?.id,
        }
      );

      setofferList(response?.data?.biddings?.pending);
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  const acceptRejectBid = async (id, status) => {
    setIsProcess(true);
    try {
      await axios.post(
        window.CARLOCA_API + "/status/bidding",
        {
          user_id: userId,
          bid_id: id,
          status: status,
        }
      );
      setIsProcess(false);
      if (buttonRef.current) {
        buttonRef.current.click();
      }
      fetchData();
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  function backto() {
    window.history.back();
  }
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <div>
              <h3 className="cl-page-title">Unlock Offers</h3>
              <p className="cl-page-subtitle">Manage incoming unlock requests</p>
            </div>
            <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left me-1"></i>Back
            </button>
          </div>
          <p className="text-muted">
            Offers will be automatically denied if you didn't accept the offers
            within 7 days of request
          </p>
          <div className="row g-3">
            {pageLoading ? (
              <SkeletonCard count={8} />
            ) : offerList?.length === 0 ? (
              <div className="cl-empty">
                <div className="cl-empty-icon"><i className="fa-solid fa-envelope-open"></i></div>
                <h6 className="cl-empty-title">No Unlock Offers</h6>
                <p className="cl-empty-text">You haven't received any unlock requests yet.</p>
              </div>
            ) : (
              offerList?.map((car) => (
                <div
                  key={car.id}
                  className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                >
                  <CarCard
                    carData={car?.car}
                    topLeftContent={
                      <i
                        title="This is to inform the seller that it will be automatically rejected after 7 days."
                        className="fa-solid fa-info-circle text-primary bg-white rounded-circle"
                        style={{ cursor: "pointer", fontSize: "16px" }}
                      ></i>
                    }
                    extraBodyContent={
                      <div className="mt-2 pt-2" style={{ borderTop: "1px solid #e5e7eb" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>From</span>
                          <span className="fw-semibold" style={{ fontSize: "12px", color: "#00889c" }}>{car.bidder.first_name} {car.bidder.last_name}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Offer</span>
                          <span className="fw-bold" style={{ fontSize: "13px", color: "#00889c" }}>£{formatEuroAmount(car.amount)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Request Type</span>
                          <span className="fw-semibold text-capitalize" style={{ fontSize: "12px", color: "#00889c" }}>{car.bid_request}</span>
                        </div>
                        <div className="d-flex gap-2 mt-1">
                          <button
                            className="btn btn-sm flex-fill"
                            style={{ fontSize: "11px", background: "#dc3545", color: "#fff", borderRadius: "6px", border: "none", fontWeight: 600 }}
                            data-bs-toggle="modal"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectId(car.id); setUserId(car.bidder?.id); }}
                            data-bs-target="#exampleModal2"
                          >
                            Deny
                          </button>
                          <button
                            className="btn btn-sm flex-fill"
                            style={{ fontSize: "11px", background: "linear-gradient(135deg, #00889c, #006f80)", color: "#fff", borderRadius: "6px", border: "none", fontWeight: 600 }}
                            data-bs-toggle="modal"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectId(car.id); setUserId(car.bidder?.id); }}
                            data-bs-target="#exampleModal1"
                          >
                            Accept
                          </button>
                        </div>
                      </div>
                    }
                    hideFooter={true}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      {/* Accept offer popup */}
      <div
        className="modal fade "
        id="exampleModal1"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body text-center mt-3 small_modal">
              <h5 className="">
                Are you sure you want to accept this request?
              </h5>
              <div className="d-flex justify-content-center mt-3">
                <button
                  onClick={() => acceptRejectBid(selectId, "accept")}
                  className="btn btn-primary btn-sm mx-2"
                  disabled={isProcess}
                >
                  {isProcess ? "Processing..." : "Yes"}
                </button>
                <button
                  className="btn btn-danger btn-sm mx-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
              </div>
            </div>
            <div className="modal-footer border-0">
              <button
                ref={buttonRef}
                className="btn btn-secondary btn-sm d-none"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Deny offer popup */}
      <div
        className="modal fade"
        id="exampleModal2"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel2"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body text-center mt-3 small_modal">
              <h5 className="">
                Are you sure you want to deny this request?
              </h5>

              <div className="d-flex justify-content-center mt-3">
                <button
                  onClick={() => acceptRejectBid(selectId, "reject")}
                  className="btn btn-primary btn-sm mx-2"
                  data-bs-dismiss="modal"
                >
                  Yes
                </button>
                <button
                  className="btn btn-danger btn-sm mx-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
              </div>
            </div>
            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MyUnlockRequest;
